// ==========================================
// RESPIDOM - Données fictives portail client
// Assistance respiratoire & matériel médical
// Location longue durée pour établissements de santé
// ==========================================

export const entreprise = {
  nom: 'RESPIDOM',
  raisonSociale: 'RESPIDOM SAS',
  adresse: '12 Avenue de la Santé, 75014 Paris',
  telephone: '01 45 XX XX XX',
  email: 'contact@respidom.com',
  siret: '852 147 369 00021',
  tvaIntra: 'FR 85 214736900',
  siteWeb: 'www.respidom.com',
  description: 'Société d\'assistance respiratoire à domicile et matériel médical.',
};

export const clientConnecte = {
  id: 'ETB-001',
  raisonSociale: 'CENTRE HOSPITALIER SAINT-MARTIN',
  type: 'Hôpital public',
  nom: 'Lefèvre',
  prenom: 'Marie',
  fonction: 'Cadre de santé - Service Pneumologie',
  email: 'm.lefevre@ch-saintmartin.fr',
  telephone: '01 42 XX XX XX',
  portable: '06 24 XX XX XX',
  adresse: '47 Boulevard de l\'Hôpital',
  codePostal: '75013',
  ville: 'Paris',
  numeroFiness: '750712184',
  siret: '267 500 015 00018',
  tvaIntra: 'FR 26 750001500',
  conditionsContrat: {
    delaiPaiement: 45,
    mode: 'Virement bancaire (mandat administratif)',
    facturationPeriode: 'Mensuelle',
    typeContrat: 'Location longue durée',
    livraisonStandard: '48h ouvrées',
    astreinte: '24h/24 - 7j/7',
  },
  dateCreation: '2022-09-14',
  commercial: 'Sophie Marchand',
  commercialTelephone: '06 78 XX XX XX',
  commercialEmail: 's.marchand@respidom.com',
};

export const encours = {
  totalDu: 8742.30,
  echeanceProcheDate: '2026-05-25',
  echeanceProcheMontant: 2845.50,
  facturesEnRetard: 1,
  montantRetard: 1456.80,
  locationsActives: 14,
  patientsEquipes: 12,
};

// ==========================================
// CATALOGUE — 4 références principales
// Tarification mensuelle de location
// ==========================================

export const materiels = [
  {
    code: 'OXY-CONC-01',
    nom: 'Concentrateur d\'oxygène',
    modele: 'Everflo 5L',
    fabricant: 'Philips Respironics',
    categorie: 'Oxygénothérapie',
    description: 'Concentrateur d\'oxygène fixe à domicile, débit 0.5 à 5 L/min, faible consommation électrique.',
    prixLocationMensuel: 95.00,
    cautionHT: 0,
    fraisInstallation: 35.00,
    duréeMinimum: 1,
    accessoires: ['Lunettes nasales', 'Tubulure 7m', 'Humidificateur'],
    image: 'concentrateur-oxygene',
    stock: 'Disponible',
  },
  {
    code: 'CPAP-AUTO-01',
    nom: 'Appareil CPAP automatique',
    modele: 'AirSense 11 AutoSet',
    fabricant: 'ResMed',
    categorie: 'Apnée du sommeil',
    description: 'Pression positive continue auto-pilotée, écran tactile, télésuivi intégré.',
    prixLocationMensuel: 78.00,
    cautionHT: 0,
    fraisInstallation: 45.00,
    duréeMinimum: 3,
    accessoires: ['Masque nasal AirFit', 'Circuit chauffant ClimateLineAir', 'Filtres'],
    image: 'cpap-automatique',
    stock: 'Disponible',
  },
  {
    code: 'VNI-BIPAP-01',
    nom: 'Ventilateur non invasif (VNI)',
    modele: 'Lumis 150 ST-A',
    fabricant: 'ResMed',
    categorie: 'Ventilation assistée',
    description: 'Ventilation à deux niveaux de pression (BiPAP) avec mode ST-A pour insuffisance respiratoire chronique.',
    prixLocationMensuel: 245.00,
    cautionHT: 0,
    fraisInstallation: 75.00,
    duréeMinimum: 3,
    accessoires: ['Masque facial', 'Circuit double branche', 'Batterie de secours'],
    image: 'vni-bipap',
    stock: 'Disponible',
  },
  {
    code: 'ASP-MOBILE-01',
    nom: 'Aspirateur de mucosités',
    modele: 'Vacu-Aide QSU',
    fabricant: 'DeVilbiss',
    categorie: 'Aspiration trachéale',
    description: 'Aspirateur portable sur batterie, vide réglable, faible niveau sonore.',
    prixLocationMensuel: 62.00,
    cautionHT: 0,
    fraisInstallation: 25.00,
    duréeMinimum: 1,
    accessoires: ['Bocal 800ml', 'Sondes d\'aspiration', 'Filtre antibactérien'],
    image: 'aspirateur-mucosites',
    stock: 'Disponible',
  },
];

// ==========================================
// LOCATIONS ACTIVES — Matériels en cours de location
// ==========================================

export const locationsActives = [
  {
    id: 'LOC-2026-0142',
    materielCode: 'OXY-CONC-01',
    materielNom: 'Concentrateur d\'oxygène Everflo 5L',
    numeroSerie: 'PHO-2024-08512',
    patientReference: 'PAT-2415',
    patientInitiales: 'D.M.',
    service: 'Pneumologie - Chambre 215',
    dateDebut: '2026-01-15',
    dateFin: null,
    duréeMois: 4,
    prixMensuel: 95.00,
    prochainePeriode: '2026-05-15',
    statut: 'active',
    technicien: 'B. Moreau',
    bonCommande: 'BC-2026-0089',
  },
  {
    id: 'LOC-2026-0141',
    materielCode: 'CPAP-AUTO-01',
    materielNom: 'CPAP AirSense 11 AutoSet',
    numeroSerie: 'RM-2025-23145',
    patientReference: 'PAT-2287',
    patientInitiales: 'L.R.',
    service: 'Pneumologie - Chambre 211',
    dateDebut: '2026-02-08',
    dateFin: null,
    duréeMois: 3,
    prixMensuel: 78.00,
    prochainePeriode: '2026-05-08',
    statut: 'active',
    technicien: 'B. Moreau',
    bonCommande: 'BC-2026-0078',
  },
  {
    id: 'LOC-2026-0140',
    materielCode: 'VNI-BIPAP-01',
    materielNom: 'VNI Lumis 150 ST-A',
    numeroSerie: 'RM-2024-19872',
    patientReference: 'PAT-2089',
    patientInitiales: 'F.A.',
    service: 'Soins intensifs - Box 4',
    dateDebut: '2025-11-22',
    dateFin: null,
    duréeMois: 5,
    prixMensuel: 245.00,
    prochainePeriode: '2026-05-22',
    statut: 'active',
    technicien: 'C. Vincent',
    bonCommande: 'BC-2025-0412',
  },
  {
    id: 'LOC-2026-0139',
    materielCode: 'ASP-MOBILE-01',
    materielNom: 'Aspirateur Vacu-Aide QSU',
    numeroSerie: 'DV-2025-04125',
    patientReference: 'PAT-2356',
    patientInitiales: 'P.B.',
    service: 'Pneumologie - Chambre 207',
    dateDebut: '2026-03-12',
    dateFin: null,
    duréeMois: 2,
    prixMensuel: 62.00,
    prochainePeriode: '2026-05-12',
    statut: 'active',
    technicien: 'B. Moreau',
    bonCommande: 'BC-2026-0095',
  },
  {
    id: 'LOC-2026-0138',
    materielCode: 'OXY-CONC-01',
    materielNom: 'Concentrateur d\'oxygène Everflo 5L',
    numeroSerie: 'PHO-2024-08498',
    patientReference: 'PAT-2401',
    patientInitiales: 'G.S.',
    service: 'Médecine interne - Chambre 312',
    dateDebut: '2026-02-28',
    dateFin: null,
    duréeMois: 2,
    prixMensuel: 95.00,
    prochainePeriode: '2026-05-28',
    statut: 'active',
    technicien: 'C. Vincent',
    bonCommande: 'BC-2026-0078',
  },
  {
    id: 'LOC-2026-0137',
    materielCode: 'CPAP-AUTO-01',
    materielNom: 'CPAP AirSense 11 AutoSet',
    numeroSerie: 'RM-2025-23089',
    patientReference: 'PAT-2298',
    patientInitiales: 'M.K.',
    service: 'Pneumologie - Chambre 218',
    dateDebut: '2026-01-30',
    dateFin: null,
    duréeMois: 3,
    prixMensuel: 78.00,
    prochainePeriode: '2026-04-30',
    statut: 'a_renouveler',
    technicien: 'B. Moreau',
    bonCommande: 'BC-2026-0089',
  },
];

// ==========================================
// LOCATIONS TERMINÉES — Historique
// ==========================================

export const locationsTerminees = [
  {
    id: 'LOC-2025-0098',
    materielCode: 'VNI-BIPAP-01',
    materielNom: 'VNI Lumis 150 ST-A',
    numeroSerie: 'RM-2024-19756',
    patientReference: 'PAT-1987',
    patientInitiales: 'R.J.',
    service: 'Soins intensifs',
    dateDebut: '2025-08-12',
    dateFin: '2026-02-10',
    duréeMois: 6,
    prixMensuel: 245.00,
    montantTotal: 1470.00,
    motifArret: 'Sortie d\'hospitalisation',
    statut: 'terminee',
  },
  {
    id: 'LOC-2025-0071',
    materielCode: 'OXY-CONC-01',
    materielNom: 'Concentrateur d\'oxygène Everflo 5L',
    numeroSerie: 'PHO-2024-08456',
    patientReference: 'PAT-1845',
    patientInitiales: 'T.O.',
    service: 'Pneumologie',
    dateDebut: '2025-06-05',
    dateFin: '2026-01-15',
    duréeMois: 7,
    prixMensuel: 95.00,
    montantTotal: 665.00,
    motifArret: 'Patient autonome - retour domicile',
    statut: 'terminee',
  },
];

// ==========================================
// FACTURES — Facturation mensuelle des locations
// ==========================================

export const factures = [
  {
    id: 'FAC-2026-0142',
    type: 'facture',
    date: '2026-04-30',
    echeance: '2026-06-14',
    montantHT: 2371.25,
    tva: 474.25,
    montantTTC: 2845.50,
    statut: 'en_attente',
    lignes: [
      { materiel: 'Concentrateur d\'oxygène Everflo 5L', reference: 'OXY-CONC-01', quantite: 2, periode: 'Avril 2026', prixUnit: 95.00, montant: 190.00 },
      { materiel: 'CPAP AirSense 11 AutoSet', reference: 'CPAP-AUTO-01', quantite: 2, periode: 'Avril 2026', prixUnit: 78.00, montant: 156.00 },
      { materiel: 'VNI Lumis 150 ST-A', reference: 'VNI-BIPAP-01', quantite: 1, periode: 'Avril 2026', prixUnit: 245.00, montant: 245.00 },
      { materiel: 'Aspirateur Vacu-Aide QSU', reference: 'ASP-MOBILE-01', quantite: 1, periode: 'Avril 2026', prixUnit: 62.00, montant: 62.00 },
    ],
    reference: 'Facturation locations - Avril 2026',
    bonCommande: 'BC-2026-0089',
    bonLivraison: 'BL-2026-0201',
  },
  {
    id: 'FAC-2026-0128',
    type: 'facture',
    date: '2026-03-31',
    echeance: '2026-05-15',
    montantHT: 2371.25,
    tva: 474.25,
    montantTTC: 2845.50,
    statut: 'en_attente',
    lignes: [
      { materiel: 'Concentrateur d\'oxygène Everflo 5L', reference: 'OXY-CONC-01', quantite: 2, periode: 'Mars 2026', prixUnit: 95.00, montant: 190.00 },
      { materiel: 'CPAP AirSense 11 AutoSet', reference: 'CPAP-AUTO-01', quantite: 2, periode: 'Mars 2026', prixUnit: 78.00, montant: 156.00 },
      { materiel: 'VNI Lumis 150 ST-A', reference: 'VNI-BIPAP-01', quantite: 1, periode: 'Mars 2026', prixUnit: 245.00, montant: 245.00 },
    ],
    reference: 'Facturation locations - Mars 2026',
    bonCommande: 'BC-2026-0078',
    bonLivraison: 'BL-2026-0189',
  },
  {
    id: 'FAC-2026-0098',
    type: 'facture',
    date: '2026-02-28',
    echeance: '2026-04-14',
    montantHT: 1214.00,
    tva: 242.80,
    montantTTC: 1456.80,
    statut: 'en_retard',
    lignes: [
      { materiel: 'VNI Lumis 150 ST-A', reference: 'VNI-BIPAP-01', quantite: 1, periode: 'Février 2026', prixUnit: 245.00, montant: 245.00 },
      { materiel: 'Concentrateur d\'oxygène Everflo 5L', reference: 'OXY-CONC-01', quantite: 1, periode: 'Février 2026', prixUnit: 95.00, montant: 95.00 },
      { materiel: 'Frais d\'installation', reference: 'INSTALL', quantite: 3, periode: 'Février 2026', prixUnit: 45.00, montant: 135.00 },
    ],
    reference: 'Facturation locations - Février 2026',
    bonCommande: 'BC-2026-0052',
    bonLivraison: 'BL-2026-0145',
  },
  {
    id: 'FAC-2026-0071',
    type: 'facture',
    date: '2026-02-10',
    echeance: '2026-03-27',
    montantHT: 1392.00,
    tva: 278.40,
    montantTTC: 1670.40,
    statut: 'payee',
    lignes: [
      { materiel: 'CPAP AirSense 11 AutoSet', reference: 'CPAP-AUTO-01', quantite: 4, periode: 'Janvier 2026', prixUnit: 78.00, montant: 312.00 },
      { materiel: 'Concentrateur d\'oxygène Everflo 5L', reference: 'OXY-CONC-01', quantite: 3, periode: 'Janvier 2026', prixUnit: 95.00, montant: 285.00 },
      { materiel: 'Aspirateur Vacu-Aide QSU', reference: 'ASP-MOBILE-01', quantite: 1, periode: 'Janvier 2026', prixUnit: 62.00, montant: 62.00 },
    ],
    reference: 'Facturation locations - Janvier 2026',
    bonCommande: 'BC-2026-0041',
    bonLivraison: 'BL-2026-0112',
  },
  {
    id: 'FAC-2025-0412',
    type: 'facture',
    date: '2025-12-31',
    echeance: '2026-02-14',
    montantHT: 1980.00,
    tva: 396.00,
    montantTTC: 2376.00,
    statut: 'payee',
    lignes: [
      { materiel: 'VNI Lumis 150 ST-A', reference: 'VNI-BIPAP-01', quantite: 2, periode: 'Décembre 2025', prixUnit: 245.00, montant: 490.00 },
      { materiel: 'CPAP AirSense 11 AutoSet', reference: 'CPAP-AUTO-01', quantite: 3, periode: 'Décembre 2025', prixUnit: 78.00, montant: 234.00 },
      { materiel: 'Concentrateur d\'oxygène Everflo 5L', reference: 'OXY-CONC-01', quantite: 2, periode: 'Décembre 2025', prixUnit: 95.00, montant: 190.00 },
    ],
    reference: 'Facturation locations - Décembre 2025',
    bonCommande: 'BC-2025-0389',
    bonLivraison: 'BL-2025-0498',
  },
  {
    id: 'FAC-2025-0380',
    type: 'facture',
    date: '2025-11-30',
    echeance: '2026-01-14',
    montantHT: 1644.00,
    tva: 328.80,
    montantTTC: 1972.80,
    statut: 'payee',
    lignes: [
      { materiel: 'CPAP AirSense 11 AutoSet', reference: 'CPAP-AUTO-01', quantite: 3, periode: 'Novembre 2025', prixUnit: 78.00, montant: 234.00 },
      { materiel: 'Concentrateur d\'oxygène Everflo 5L', reference: 'OXY-CONC-01', quantite: 2, periode: 'Novembre 2025', prixUnit: 95.00, montant: 190.00 },
      { materiel: 'VNI Lumis 150 ST-A', reference: 'VNI-BIPAP-01', quantite: 1, periode: 'Novembre 2025', prixUnit: 245.00, montant: 245.00 },
    ],
    reference: 'Facturation locations - Novembre 2025',
    bonCommande: 'BC-2025-0361',
    bonLivraison: 'BL-2025-0472',
  },
];

// ==========================================
// BONS DE COMMANDE — Générés automatiquement à la commande
// ==========================================

export const bonsCommande = [
  {
    id: 'BC-2026-0089',
    type: 'bon_commande',
    date: '2026-04-08',
    montantHT: 326.00,
    tva: 65.20,
    montantTTC: 391.20,
    statut: 'livre',
    reference: 'Mise en location - Service Pneumologie',
    service: 'Pneumologie',
    typePrestation: 'Location longue durée',
    lignes: [
      { materiel: 'Concentrateur d\'oxygène Everflo 5L', reference: 'OXY-CONC-01', quantite: 1, prixUnit: 95.00, montant: 95.00, periode: 'Mensuel' },
      { materiel: 'CPAP AirSense 11 AutoSet', reference: 'CPAP-AUTO-01', quantite: 1, prixUnit: 78.00, montant: 78.00, periode: 'Mensuel' },
      { materiel: 'Frais d\'installation x2', reference: 'INSTALL', quantite: 1, prixUnit: 80.00, montant: 80.00, periode: 'Unique' },
    ],
    facture: 'FAC-2026-0142',
    bonLivraison: 'BL-2026-0201',
    locationsAssociees: ['LOC-2026-0142', 'LOC-2026-0137'],
  },
  {
    id: 'BC-2026-0078',
    type: 'bon_commande',
    date: '2026-02-25',
    montantHT: 173.00,
    tva: 34.60,
    montantTTC: 207.60,
    statut: 'livre',
    reference: 'Mise en location - Pneumologie & Médecine interne',
    service: 'Multi-services',
    typePrestation: 'Location longue durée',
    lignes: [
      { materiel: 'CPAP AirSense 11 AutoSet', reference: 'CPAP-AUTO-01', quantite: 1, prixUnit: 78.00, montant: 78.00, periode: 'Mensuel' },
      { materiel: 'Concentrateur d\'oxygène Everflo 5L', reference: 'OXY-CONC-01', quantite: 1, prixUnit: 95.00, montant: 95.00, periode: 'Mensuel' },
    ],
    facture: 'FAC-2026-0128',
    bonLivraison: 'BL-2026-0189',
    locationsAssociees: ['LOC-2026-0141', 'LOC-2026-0138'],
  },
  {
    id: 'BC-2026-0095',
    type: 'bon_commande',
    date: '2026-03-10',
    montantHT: 87.00,
    tva: 17.40,
    montantTTC: 104.40,
    statut: 'en_cours',
    reference: 'Mise en location - Service Pneumologie',
    service: 'Pneumologie',
    typePrestation: 'Location longue durée',
    lignes: [
      { materiel: 'Aspirateur Vacu-Aide QSU', reference: 'ASP-MOBILE-01', quantite: 1, prixUnit: 62.00, montant: 62.00, periode: 'Mensuel' },
      { materiel: 'Frais d\'installation', reference: 'INSTALL', quantite: 1, prixUnit: 25.00, montant: 25.00, periode: 'Unique' },
    ],
    facture: null,
    bonLivraison: null,
    locationsAssociees: ['LOC-2026-0139'],
  },
  {
    id: 'BC-2026-0052',
    type: 'bon_commande',
    date: '2025-11-20',
    montantHT: 320.00,
    tva: 64.00,
    montantTTC: 384.00,
    statut: 'livre',
    reference: 'Mise en location - Soins intensifs',
    service: 'Soins intensifs',
    typePrestation: 'Location longue durée',
    lignes: [
      { materiel: 'VNI Lumis 150 ST-A', reference: 'VNI-BIPAP-01', quantite: 1, prixUnit: 245.00, montant: 245.00, periode: 'Mensuel' },
      { materiel: 'Frais d\'installation VNI', reference: 'INSTALL', quantite: 1, prixUnit: 75.00, montant: 75.00, periode: 'Unique' },
    ],
    facture: 'FAC-2026-0098',
    bonLivraison: 'BL-2026-0145',
    locationsAssociees: ['LOC-2026-0140'],
  },
  {
    id: 'BC-2026-0041',
    type: 'bon_commande',
    date: '2026-01-08',
    montantHT: 235.00,
    tva: 47.00,
    montantTTC: 282.00,
    statut: 'livre',
    reference: 'Renouvellement parc location',
    service: 'Pneumologie',
    typePrestation: 'Location longue durée',
    lignes: [
      { materiel: 'CPAP AirSense 11 AutoSet', reference: 'CPAP-AUTO-01', quantite: 1, prixUnit: 78.00, montant: 78.00, periode: 'Mensuel' },
      { materiel: 'Aspirateur Vacu-Aide QSU', reference: 'ASP-MOBILE-01', quantite: 1, prixUnit: 62.00, montant: 62.00, periode: 'Mensuel' },
      { materiel: 'Frais d\'installation', reference: 'INSTALL', quantite: 1, prixUnit: 70.00, montant: 70.00, periode: 'Unique' },
    ],
    facture: 'FAC-2026-0071',
    bonLivraison: 'BL-2026-0112',
    locationsAssociees: [],
  },
];

// ==========================================
// BONS DE LIVRAISON — Installation et reprise sur site
// ==========================================

export const bonsLivraison = [
  {
    id: 'BL-2026-0201',
    type: 'bon_livraison',
    date: '2026-04-10',
    statut: 'livre',
    reference: 'Installation matériel - Service Pneumologie',
    adresseLivraison: '47 Bd de l\'Hôpital, 75013 Paris - Service Pneumologie 2e étage',
    typeIntervention: 'Installation',
    technicien: 'Moreau B.',
    immatriculation: 'AB-456-CD',
    heureDepart: '08:00',
    heureArrivee: '09:30',
    lignes: [
      { materiel: 'Concentrateur d\'oxygène Everflo 5L', reference: 'OXY-CONC-01', quantite: 1, numeroSerie: 'PHO-2024-08512', controle: 'OK' },
      { materiel: 'CPAP AirSense 11 AutoSet', reference: 'CPAP-AUTO-01', quantite: 1, numeroSerie: 'RM-2025-23089', controle: 'OK' },
    ],
    bonCommande: 'BC-2026-0089',
    facture: 'FAC-2026-0142',
    signataireClient: 'Dr. Bernard - Chef de service',
    observations: 'Installation et formation utilisateur réalisées. Patient et personnel briefés sur l\'utilisation.',
  },
  {
    id: 'BL-2026-0189',
    type: 'bon_livraison',
    date: '2026-02-28',
    statut: 'livre',
    reference: 'Installation - Pneumologie & Médecine interne',
    adresseLivraison: '47 Bd de l\'Hôpital, 75013 Paris - Pneumologie + Médecine interne',
    typeIntervention: 'Installation',
    technicien: 'Moreau B.',
    immatriculation: 'AB-456-CD',
    heureDepart: '07:30',
    heureArrivee: '10:00',
    lignes: [
      { materiel: 'CPAP AirSense 11 AutoSet', reference: 'CPAP-AUTO-01', quantite: 1, numeroSerie: 'RM-2025-23145', controle: 'OK' },
      { materiel: 'Concentrateur d\'oxygène Everflo 5L', reference: 'OXY-CONC-01', quantite: 1, numeroSerie: 'PHO-2024-08498', controle: 'OK' },
    ],
    bonCommande: 'BC-2026-0078',
    facture: 'FAC-2026-0128',
    signataireClient: 'M. Lefèvre - Cadre de santé',
    observations: '',
  },
  {
    id: 'BL-2026-0145',
    type: 'bon_livraison',
    date: '2025-11-22',
    statut: 'livre',
    reference: 'Installation VNI - Soins intensifs',
    adresseLivraison: '47 Bd de l\'Hôpital, 75013 Paris - Soins intensifs',
    typeIntervention: 'Installation',
    technicien: 'Vincent C.',
    immatriculation: 'EF-789-GH',
    heureDepart: '14:00',
    heureArrivee: '16:30',
    lignes: [
      { materiel: 'VNI Lumis 150 ST-A', reference: 'VNI-BIPAP-01', quantite: 1, numeroSerie: 'RM-2024-19872', controle: 'OK' },
    ],
    bonCommande: 'BC-2026-0052',
    facture: 'FAC-2026-0098',
    signataireClient: 'Dr. Caron - Réanimateur',
    observations: 'Réglages personnalisés effectués selon prescription médicale. Astreinte 24/7 communiquée.',
  },
  {
    id: 'BL-2026-0112',
    type: 'bon_livraison',
    date: '2026-01-12',
    statut: 'livre',
    reference: 'Renouvellement parc - Pneumologie',
    adresseLivraison: '47 Bd de l\'Hôpital, 75013 Paris - Service Pneumologie',
    typeIntervention: 'Installation',
    technicien: 'Moreau B.',
    immatriculation: 'AB-456-CD',
    heureDepart: '09:00',
    heureArrivee: '10:00',
    lignes: [
      { materiel: 'CPAP AirSense 11 AutoSet', reference: 'CPAP-AUTO-01', quantite: 1, numeroSerie: 'RM-2025-23052', controle: 'OK' },
      { materiel: 'Aspirateur Vacu-Aide QSU', reference: 'ASP-MOBILE-01', quantite: 1, numeroSerie: 'DV-2025-04125', controle: 'OK' },
    ],
    bonCommande: 'BC-2026-0041',
    facture: 'FAC-2026-0071',
    signataireClient: 'M. Lefèvre - Cadre de santé',
    observations: '',
  },
];

// ==========================================
// HISTORIQUE DES RÈGLEMENTS
// ==========================================

export const historiqueReglements = [
  { date: '2026-03-25', montant: 1670.40, mode: 'Virement', reference: 'FAC-2026-0071' },
  { date: '2026-02-12', montant: 2376.00, mode: 'Virement', reference: 'FAC-2025-0412' },
  { date: '2026-01-14', montant: 1972.80, mode: 'Virement', reference: 'FAC-2025-0380' },
  { date: '2025-12-18', montant: 2154.00, mode: 'Virement', reference: 'FAC-2025-0342' },
];

// ==========================================
// HELPERS
// ==========================================

export const formatMontant = (montant) => {
  return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(montant);
};

export const formatDate = (dateStr) => {
  if (!dateStr) return '—';
  const date = new Date(dateStr);
  return date.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

export const calculerDureeMois = (dateDebut, dateFin = null) => {
  const debut = new Date(dateDebut);
  const fin = dateFin ? new Date(dateFin) : new Date();
  const mois = (fin.getFullYear() - debut.getFullYear()) * 12 + (fin.getMonth() - debut.getMonth());
  return Math.max(1, mois);
};

export const getStatutLabel = (statut) => {
  const labels = {
    en_attente: 'En attente',
    en_retard: 'En retard',
    payee: 'Payée',
    en_cours: 'En cours',
    livre: 'Livré',
    annulee: 'Annulée',
    validee: 'Validée',
    active: 'Active',
    a_renouveler: 'À renouveler',
    terminee: 'Terminée',
    arretee: 'Arrêtée',
  };
  return labels[statut] || statut;
};

export const getStatutColor = (statut) => {
  const colors = {
    en_attente: { bg: '#FEF3C7', color: '#92400E', border: '#FDE68A' },
    en_retard: { bg: '#FEE2E2', color: '#991B1B', border: '#FECACA' },
    payee: { bg: '#D1FAE5', color: '#065F46', border: '#A7F3D0' },
    en_cours: { bg: '#DBEAFE', color: '#1E40AF', border: '#BFDBFE' },
    livre: { bg: '#D1FAE5', color: '#065F46', border: '#A7F3D0' },
    annulee: { bg: '#F3F4F6', color: '#6B7280', border: '#E5E7EB' },
    validee: { bg: '#DBEAFE', color: '#1E40AF', border: '#BFDBFE' },
    active: { bg: '#CFFAFE', color: '#0E7490', border: '#A5F3FC' },
    a_renouveler: { bg: '#FEF3C7', color: '#92400E', border: '#FDE68A' },
    terminee: { bg: '#F3F4F6', color: '#6B7280', border: '#E5E7EB' },
    arretee: { bg: '#FEE2E2', color: '#991B1B', border: '#FECACA' },
  };
  return colors[statut] || { bg: '#F3F4F6', color: '#6B7280', border: '#E5E7EB' };
};
